import { createFileRoute } from '@tanstack/react-router';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/_app/operator/')({
  staticData: { crumb: 'Pulpit' },
  component: OperatorDashboard,
});

function OperatorDashboard() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-2xl font-semibold tracking-tight text-text">
          Operator pulpit
        </h1>
        <p className="mt-1 text-sm text-text-muted">
          Tu wylądują kontrolki cross-tenant: lista klientów, skrzynka rozmów,
          recenzje doktora, audit log.
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>Status systemu</CardTitle>
          <CardDescription>Skróty do najczęstszych operacji.</CardDescription>
        </CardHeader>
        <CardContent className="grid gap-3 sm:grid-cols-2">
          <a
            href="/operator/tenants"
            className="rounded-md bg-surface p-4 text-sm ring-1 ring-black/5 hover:ring-black/10"
          >
            <span className="block font-medium text-text">Klienci</span>
            <span className="block text-text-muted">Lista klinik + statusy + impersonacja</span>
          </a>
          <a
            href="/operator/conversations"
            className="rounded-md bg-surface p-4 text-sm ring-1 ring-black/5 hover:ring-black/10"
          >
            <span className="block font-medium text-text">Skrzynka rozmów</span>
            <span className="block text-text-muted">Konwersacje email-agenta do triage</span>
          </a>
        </CardContent>
      </Card>
    </div>
  );
}
